import { useSettings } from '../../../hooks/useSettings/useSettings';

/**
 * Is this a policystream organization? If strict is true (the default) then the organization must *only* be a policystream one, but if not we just check to see that it can access the policystream stuff
 * @param strict - is this *only* a policystream organization or can it access other parts of the system as well?
 * @returns - boolen - whether or not it's a policystream organization
 */
export const useIsPolicyStreamOrganization = (strict: boolean = true) => {
  const { settings } = useSettings();
  const { types } = settings;
  //if its not strictly a policystream organization, check if the types is only life insurance
  if (strict) {
    return types.includes('LIFE') && types.length === 1;
  }
  //else, if they are a life insurance company then they are a policystream organization
  return types.includes('LIFE');
};
